import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconChart } from "../../components/Icons";

const ACCENT = "#22C55E";

const FAQS = [
  {
    question: "O ERP Bruning funciona pelo navegador?",
    answer:
      "Sim. Por ser SaaS em nuvem, o ERP Bruning funciona pelo navegador em qualquer computador, sem instalação local necessária.",
  },
  {
    question: "A sepolTECH faz a migração de dados do sistema atual?",
    answer:
      "Sim, dentro das possibilidades técnicas. Na implantação, planejamos junto com você a migração de dados do sistema atual para o ERP Bruning.",
  },
  {
    question: "Quantos usuários podem usar o sistema?",
    answer:
      "O número de usuários depende do plano contratado. Entre em contato para uma proposta adequada ao seu negócio.",
  },
  {
    question:
      "Qual a diferença de contratar pelo sepolTECH vs direto com a Bruning?",
    answer:
      "Ao contratar pelo sepolTECH, você tem implantação, treinamento, suporte técnico e gestão de TI em um único parceiro. Nossa equipe conhece tanto o ERP quanto a infraestrutura de TI da sua empresa.",
  },
];

const FEATURES = [
  {
    title: "ERP em Nuvem",
    desc: "Acesse o sistema de qualquer lugar, sem instalação local ou servidor dedicado",
  },
  {
    title: "Gestão Integrada",
    desc: "Financeiro, estoque, vendas, compras, fiscal e mais em um único sistema",
  },
  {
    title: "Implantação pela sepolTECH",
    desc: "Nossa equipe realiza toda a configuração e parametrização do sistema",
  },
  {
    title: "Treinamento Incluído",
    desc: "Treinamento para a equipe na implantação, sem custo adicional",
  },
  {
    title: "Suporte Contínuo",
    desc: "Suporte técnico ao ERP incluso no contrato mensal da sepolTECH",
  },
  {
    title: "Parceria Bruning",
    desc: "Sistema desenvolvido pela Bruning Sistemas, referência no mercado de ERP para PMEs",
  },
];

export default function ErpBruning() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/produtos/produtos">Produtos</Link>
            <span>/</span>
            <span>ERP Bruning</span>
          </div>
          <div className="tag animate-up animate-up--d1" style={{ color: ACCENT, background: "rgba(34,197,94,.12)", borderColor: `${ACCENT}40` }}>
            <IconChart style={{ width: "13px", height: "13px" }} />
            SaaS ERP · Bruning Sistemas
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(40px,6vw,72px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.05",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            <span style={{ color: ACCENT }}>ERP</span> Bruning
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "540px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Sistema de Gestão Empresarial integrado em nuvem. A sepolTECH
            realiza a implantação, treinamento e suporte contínuo — gestão
            completa com quem entende de TI.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Contratar ERP Bruning →
            </Link>
            <Link to="/contato" className="btn btn-outline">
              Falar com especialista
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ RECURSOS INCLUSOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal>
            <div className="tag" style={{ color: ACCENT, background: "rgba(34,197,94,.12)", borderColor: `${ACCENT}40` }}>
              Recursos inclusos
            </div>
            <h2 className="section-title" style={{ marginBottom: "36px" }}>
              O que você recebe com <span style={{ color: ACCENT }}>ERP Bruning</span>
            </h2>
            <div className="feature-list">
              {FEATURES.map((feature) => (
                <div className="feature-item" key={feature.title}>
                  <div
                    className="feature-item__icon"
                    style={{ background: "rgba(34,197,94,.12)", color: ACCENT }}
                  >
                    ✓
                  </div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>{feature.title}</strong> —{" "}
                    {feature.desc}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "760px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag" style={{ color: ACCENT, background: "rgba(34,197,94,.12)", borderColor: `${ACCENT}40` }}>
              FAQ
            </div>
            <h2 className="section-title">
              Dúvidas sobre <span style={{ color: ACCENT }}>ERP Bruning</span>
            </h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.05}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              Gestão completa da sua empresa em um único sistema
            </h2>
            <p className="cta-banner__sub">
              ERP Bruning implantado e suportado pela sepolTECH.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Contratar ERP Bruning →
              </Link>
              <Link to="/produtos/produtos" className="btn btn-outline">
                Ver outros produtos
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
